import React, { useState } from "react";
import NewMainRegister from "../Components/Register/NewMainRegister";
// import MainRegister from "../Components/Register/MainRegister";
import { ChevronLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";
import {useThemeClass} from '@/Hooks/useThemeClass'
import clsx from 'clsx';

function Register() {
  const themeClass = useThemeClass()
  return (
    <>
      <div>
        <div className="px-3 ">
          <div className={clsx(themeClass.text('text'), themeClass.border('text'), `flex justify-between items-center py-3 border-b`)}>
            <Link to="/login">
              <ChevronLeft />
            </Link>
            <p className="text-[18px] font-bold">회원가입</p>
            <Link to="/" className="flex text-[12px] items-center text-center ">
              <Home />
            </Link>
          </div>
          {/* <MainRegister/> */}
          <NewMainRegister />
        </div>
      </div>
    </>
  );
}

export default Register;
